export default [
  {
    path: '/CommunityGas/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'CommunityGas',
        component: () => import('@/views/CommunityGas/CommunityGas.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      },
      {
        path: '/CommunityGasOverView/:id/:ym',
        name: 'CommunityGasOverView',
        component: () => import('@/views/CommunityGas/CommunityGasOverView.vue'),
        meta: {
          prev: 'CommunityGas'
        }
      }
    ]
  }
]
